module.exports = __webpack_public_path__ + "static/media/ocasio-cortez.65b0924a.png";